import Vue from 'vue'
const FileUpload = require('vue-upload-component')

Vue.component('file-upload', FileUpload)
